import { Component, Vue } from 'vue-property-decorator';
import { SECTION_TYPES } from '@/content/values/sections';
import { Section } from '../models/section.model';

@Component({})
export class WriteObjectMixin extends Vue {

  getProblemToDownload(section: Section, problem: any) {
    if(section.type == SECTION_TYPES.SPLIT_QUESTION_PDF.code) {
      return section;
    } else if(section.type == SECTION_TYPES.SPLIT_QUESTION_MATERIAL.code) {
      return {
        ...section,
        assetsInfo: [{
          hash: (section.text) ? section.text : 
            (section.sectionMaterial.materialAssetInfo.pdfHash) ? section.sectionMaterial.materialAssetInfo.pdfHash : section.sectionMaterial.materialAssetInfo.hash
        }]
      };
    }
    return problem;
  }

  getSolutionToDownload(section: Section, solution: any) {
    if(section.type == SECTION_TYPES.SPLIT_SOLUTION_PDF.code) {
      return section;
    } else if(section.type == SECTION_TYPES.SPLIT_SOLUTION_MATERIAL.code) {
      return {
        ...section,
        assetsInfo: [{
          hash: (section.text) ? section.text : 
            (section.sectionMaterial.materialAssetInfo.pdfHash) ? section.sectionMaterial.materialAssetInfo.pdfHash : section.sectionMaterial.materialAssetInfo.hash
        }]
      };
    }
    return solution;
  }

}
